module.exports = __webpack_public_path__ + "static/media/cross-mark-icon.e7939644.png";